<template>
  <div
    @drop.prevent="dropStart($event)"
    @dragleave="leaveFile($event)"
    class="add-file"
  >
    <div
      :class="[
        'add-file__window',
        { 'add-file__window--dragenter': dragenter },
        { 'add-file__window--drop': showBackSide },
      ]"
    >
      <div v-if="!showBackSide" class="window__front-side">
        <div
          v-if="dragStart"
          dropzone="copy"
          @dragleave="dragLeaveF($event)"
          @dragenter="dragEnterF($event)"
          class="drop-zone"
        ></div>
        <button @click="closeWindow(false)" class="add-file__close-btn">
          <i class="fas fa-times"></i>
        </button>
        <span class="window__text">Перетащите файл сюда</span>
      </div>
      <div class="window__back-side" v-else>
        <div
          v-if="dragStart"
          dropzone="copy"
          @dragleave="dragLeaveF($event)"
          @dragenter="dragEnterF($event)"
          class="drop-zone"
        ></div>
        <button @click="closeWindow(false)" class="add-file__close-btn">
          <i class="fas fa-times"></i>
        </button>
        <div class="file-list">
          <div v-for="(file, idx) of files" class="file-list__item" :key="idx">
            <i :class="checkImage(file) ? 'fas fa-file-image' : 'fas fa-file'" class="file-icon"></i>
            <span class="item__size">{{
              Math.ceil(file.size / 1024) + " КБ"
            }}</span>
            <input
              :class="[
                'item__name',
                { 'item__name--edit': editableFile === idx },
              ]"
              :ref="'file-name' + idx"
              :readonly="editableFile !== idx"
              type="text"
              v-model="file.newName"
            />
            <div class="item__control-block">
              <transition name="fade">
                <button
                  v-if="editableFile === idx"
                  @click="saveNewFileName(file)"
                  class="item__edit-btn"
                >
                  <i class="fas fa-save"></i>
                </button>
                <button
                  v-else
                  @click="editUploadFile(idx, file)"
                  class="item__edit-btn"
                >
                  <i class="fas fa-edit"></i>
                </button>
              </transition>
              <button @click="removeUploadFile(idx)" class="item__remove-btn">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <input
          v-model="message"
          placeholder="Сообщение"
          class="message-input"
        />
        <div class="back-side__button-block">
          <button class="add-file__upload-files">
            Добавить
            <input
              multiple
              class="input-load-file"
              ref="input-load-file"
              @change="loadFile"
              type="file"
            />
          </button>
          <button @click="sendFile" class="add-file__upload-files">
            Отправить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "addFile",
  data() {
    return {
      showBackSide: false,
      dropZoneActive: false,
      message: '',
      editableFile: null,
      dragenter: false,
      drop: false,
      files: [],
    };
  },
  watch: {
    editableFile() {
      this.editableFile !== null
        ? this.$nextTick(() => this.$refs[`file-name${this.editableFile}`][0].focus())
        : null;
    },
  },
  props: {
    dragStart: Boolean,
    selectedChat: Object,
  },
  methods: {
    notify(type, text) {
      const h = this.$createElement;
      this.$notify({
        title: "",
        message: h(
          "i",
          { style: `color: ${type === 'success' ? '#67c23a' : '#f56c6c'}` },
          text
        ),
        position: "bottom-right",
      });
    },
    leaveFile(e) {
      if (
        (e.relatedTarget?.id === 'chat-list' || e.relatedTarget === null)
        && !this.files.length
      ) {
        this.closeWindow(false);
      }
    },
    closeWindow(value) {
      this.files = [];
      this.$emit('close', { update: value });
    },
    dragLeaveF() {
      this.dragenter = false;
    },
    dragEnterF() {
      this.dragenter = true;
    },
    checkQuantity() {
      const result = this.files.length <= 3;
      if (!result) {
        this.notify('error', 'Превышено количество файлов (максимум 3)');
      }
      return result;
    },
    checkRepeatFile(name) {
      const result = Boolean(this.files.find((file) => file.name === name));
      if (result) {
        this.notify('error', 'Файл с таким именем уже загружен');
      }
      return result;
    },
    sendFile() {
      const formData = new FormData();
      this.files.forEach((file) => {
        formData.append('file[]', file, file.newName);
      });
      formData.append('recipient', this.selectedChat.id);
      formData.append('text', this.message ? this.message : '');

      this.axios.post('/api/messages', formData).then((res) => {
        if (res.data.status) {
          this.notify('success', 'Файлы успешно отправлены');
          this.$emit('sent');
        } else {
          this.notify('error', 'Ошибка отправки файлов');
        }
        this.closeWindow(res.data.status);
      });
    },
    addFile(files) {
      if (!this.showBackSide) this.showBackSide = true;
      this.checkQuantity()
        ? files.forEach((file) => {
          if (!this.checkRepeatFile(file.name) && this.checkQuantity()) {
            file.newName = file.name;
            this.files.push(file);
          }
        })
        : null;
    },
    loadFile() {
      this.addFile([...this.$refs['input-load-file'].files]);
    },
    editUploadFile(index, file) {
      this.editableFile = index;
    },
    checkImage(v) {
      return v.type.match('image.*');
    },
    removeUploadFile(idx) {
      this.files.splice(idx, 1);
      this.files.length === 0 ? this.$emit('close', { update: false }) : null;
    },
    saveNewFileName(file) {
      this.editableFile = null;
    },
    dropStart(e) {
      this.showBackSide = true;
      this.dragenter = false;
      this.$emit('dropFile');
      this.addFile([...e.dataTransfer.files]);
    },
  },
};
</script>

<style lang="scss">
.add-file {
  transition-duration: 0.3s;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.3);

  .add-file__window {
    position: relative;
    transition-duration: 0.3s;
    transition-property: all;
    perspective: 500px;
    width: 90%;
    max-width: 400px;
    max-height: 400px;
    min-height: 250px;
    background-color: #f5f5f5;
    border-radius: 10px;
    border: 2px solid transparent;
  }

  .add-file__window--dragenter {
    border: 2px dashed $brand-clr-1;
    .window__text {
      color: $brand-clr-1;
    }
  }

  .add-file__window--drop {
    transform: translateZ(-100px) rotateY(180deg);
  }

  .window__text {
    transition-duration: 0.3s;
    transition-property: color;
    font-weight: bold;
    font-size: 18px;
    color: #999;
  }

  .add-file__close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    justify-self: flex-end;
    background-color: $brand-clr-1;
    border-radius: 5px;
    cursor: pointer;
    i {
      color: white;
      font-size: 12px;
    }
  }

  .window__front-side {
    align-items: center;
    justify-items: center;
    padding: 20px;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: max-content 1fr;
    position: absolute;
  }

  .window__back-side {
    row-gap: 15px;
    padding: 20px;
    transform: scaleX(-1);
    display: grid;
    grid-template-rows: max-content 1fr max-content max-content;
    width: 100%;
    height: 100%;
  }

  .file-list {
    display: grid;
    grid-auto-rows: max-content;
    align-self: center;
    row-gap: 10px;
    align-items: center;
    padding: 10px 0;
  }

  .file-list__item {
    display: grid;
    row-gap: 5px;
    width: auto;
    height: max-content;
    justify-items: center;
    align-items: center;
    align-self: center;
    column-gap: 5px;
    grid-template-columns: max-content 1fr max-content;
    grid-template-areas:
      "icon name button"
      "icon size .";

    .file-icon {
      grid-area: icon;
      font-size: 28px;
      color: $brand-clr-1;
    }
  }

  .item__size {
    padding: 0 5px;
    grid-area: size;
    justify-self: flex-start;
    font-size: 12px;
    color: #999;
  }

  .item__name {
    width: 100%;
    padding: 2px 5px;
    transition-property: border-color;
    transition-duration: 0.3s;
    background-color: transparent;
    justify-self: flex-start;
    grid-area: name;
    font-weight: bold;
    font-size: 14px;
    color: #333;
    border: 1px solid transparent;
    border-radius: 5px;
    outline: none;
    &:focus {
      border-color: $brand-clr-1;
    }
  }

  .item__name--edit {
    background-color: #e0e0e0;
    padding-left: 10px;
  }

  .item__control-block {
    grid-area: button;
    display: flex;
    gap: 5px;
  }

  .item__edit-btn,
  .item__remove-btn {
    background-color: transparent;
    cursor: pointer;
    i {
      font-size: 14px;
      color: $brand-clr-1;
    }
  }

  .message-input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    outline: none;
    &:focus {
      border-color: $brand-clr-1;
    }
    &::placeholder {
      color: #999;
    }
  }

  .add-file__upload-files {
    position: relative;
    font-size: 16px;
    color: $brand-clr-1;
    font-weight: bold;
    background-color: transparent;
    cursor: pointer;
  }

  .add-file__upload-files:first-child {
    justify-self: flex-start;
  }

  .add-file__upload-files:last-child {
    justify-self: flex-end;
  }

  .back-side__button-block {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .input-load-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  .drop-zone {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
